module.exports = __webpack_public_path__ + "static/media/Minus.63a2c136.svg";